export interface Urls {
  /** Standard HTTP for REST and GraphQL */
  api: string;
  /** Web Sockets */
  ws: string;
  /** Application context path */
  basePath: string;
  /** External OpenAPI documentation */
  xapi: string;
}

const apiPort = import.meta.env.MIDDLE_TIER_PORT ? Number.parseInt(import.meta.env.MIDDLE_TIER_PORT, 10) : 9000;
const serverUsesLocalhost = import.meta.env.DEV_USES_LOCALHOST
  ? Number.parseInt(import.meta.env.DEV_USES_LOCALHOST, 10) > 0
  : true;

// Defined in `.env.development.local` or as global env vars.
const configuredApiUrl = import.meta.env.VITE_API_BASE_URL;
const configuredWsUrl = import.meta.env.VITE_WS_BASE_URL;

// Calculate context path once
const applicationPath = location.pathname === "/" ? "/" : `/${location.pathname.split("/")[1]}/`;
// Localhost configuration
const localDevEnvironment: Urls = {
  api: configuredApiUrl ? `${configuredApiUrl}api` : `http://localhost:${apiPort}/api`,
  ws: configuredWsUrl ? `${configuredWsUrl}ws` : `ws://localhost:${apiPort}/ws`,
  basePath: "/",
  xapi: configuredApiUrl ? `${configuredApiUrl}xapi/docs/` : `http://localhost:${apiPort}/xapi/docs/`,
};

// Host interface configuration
const networkDevEnvironment: Urls = {
  api: `${location.protocol}//${location.hostname}:${apiPort}/api`,
  ws: `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.hostname}:${apiPort}/ws`,
  basePath: "/",
  xapi: `${location.protocol}//${location.hostname}:${apiPort}/xapi/docs/`,
};

// Production configuration
const productionEnvironment: Urls = {
  api: `${location.protocol}//${location.host}${applicationPath}api`,
  ws: `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}${applicationPath}ws`,
  basePath: applicationPath,
  xapi: `${location.protocol}//${location.host}${applicationPath}xapi/docs/`,
};

export const urls: Urls = import.meta.env.PROD
  ? productionEnvironment
  : serverUsesLocalhost
    ? localDevEnvironment
    : networkDevEnvironment;
